export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/venture-beat-3a9d8202fcc328d9693a182ffa68c115.png";